export interface Config {
  monitoring: {
    unique_offer_id_param: string;
  };
  chatbot: {
    open_modal_url_param: string;
  };
  socket: {
    url?: string;
    port: number;
    enable_sockets?: boolean;
    reconnectionAttempts: number;
    reconnectionDelay: number;
    allowed_origins?: string[];
  };
  backend: {
    base_url: string;
  };
  assets?: {
    base_url: string;
  };
  env: "development" | "production";
}

export function defineConfig(config: Config): Config {
  return config;
}
